(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/fathersDay2024/fathers-day.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/fathersDay2024/fathers-day.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const fathersDay2024Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/fathersDay2024");
const TopFrame = () => React.createElement("div", {
  className: "fathers-day-top-frame row pointer-none"
}, React.createElement("div", {
  className: "fathers-day-top-frame-container relative col-md-12"
}, React.createElement("img", {
  alt: "Farsdag-ram-\xF6verdel",
  className: "top-frame-fathers-day",
  src: "".concat(fathersDay2024Path, "/farsdag-ram-topp.svg")
})));
const BottomFrame = () => React.createElement("div", {
  className: "fathers-day-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "fathers-day-bottom-layers relative col-md-12"
}, React.createElement("img", {
  alt: "Farsdag-ram-nederdel",
  className: "bottom-frame-fathers-day",
  src: "".concat(fathersDay2024Path, "/farsdag-ram-botten.svg")
})));
const FathersDay = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.fathersDay2024.FathersDay', FathersDay);

 })(window);